import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900">
            漫画分类
          </h2>
          <p className="text-sm text-foreground-500 mt-1">按分类找到你喜欢的漫画类型</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex items-center gap-4 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors shrink-0">
                <i className={`${cat.icon} text-lg`}></i>
              </div>
              <div>
                <h3 className="font-heading text-sm text-foreground-900 group-hover:text-primary-500 transition-colors">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5">{cat.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}